/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {Dialog, PopupMenu, Tooltip} from "@intuitionrobotics/thunderstorm/frontend";
import {EnvironmentModule} from "@modules/EnvironmentModule";
import {BugReport} from "@intuitionrobotics/bug-report/app-frontend/ui/BugReport";
import {ErrorBoundary} from "./utils/ErrorBoundary";
import {DemoToggle} from "./DemoToggle";
import {MyToaster} from "./utils/MyToaster";
import {Page_Home} from "./pages/home/Page_Home";
import {AppContextProvider} from "./AppContextProvider";

export const AppHome = () => {
    return <AppContextProvider>
        <div
            className={"full_screen"}
            onDrop={(ev) => {
                ev.preventDefault();
                ev.stopPropagation();
            }}
            onDragOver={(ev) => {
                ev.preventDefault();
                ev.stopPropagation();
            }}
            style={{backgroundColor: "white"}}
        >
            <ErrorBoundary>
                <Page_Home/>
            </ErrorBoundary>
            <Dialog/>
            <MyToaster/>
            {!EnvironmentModule.isProd() && <BugReport><span/></BugReport>}
            <DemoToggle/>
            <PopupMenu/>
            <Tooltip/>
        </div>
    </AppContextProvider>

}
